/**
 * Mixin can be used to add default form states to a form-element.
 * For modifiers class names combine the component modifier() computed function with the stateModifier()
 * computed function
 *
 * @mixin
 */
export default {
  props: {
    /**
     * Form states for class names (default, error, success, warning, info)
     */
    state: {
      type: String,
      default: 'default',
      validator(value) {
        return ['error', 'success', 'warning', 'info', 'default'].includes(value);
      },
    },

    /**
     * `form-states mixin` Forces active state
     */
    active: {
      type: Boolean,
      default: false,
    },

    /**
     * `form-states mixin` Forces disabled state
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * `form-states mixin` Forces focus state
     */
    focus: {
      type: Boolean,
      default: false,
    },

    /**
     * `form-states mixin` Adds hover state
     */
    hover: {
      type: Boolean,
      default: false,
    },

    /**
     * Initially selected active values.
     *
     * Attention, this was added during the vue3 update. Some logic within filters
     * rely on the value in some cases. TODO: this needs to be refactored.
     */
    value: {
      type: [String, Number, Array],
      default: null,
    },

    /**
     * Defines the class on the root element.
     */
    rootClass: {
      type: String,
      default: null,
    },
  },

  /**
   * Default data for the mixin props (will be merged with the components data function).
   *
   * @returns {{isActive: *, hasFocus: *, hasHover: (hover|{type, default}|*)}}
   */
  data() {
    return {
      isActive: this.active,
      hasFocus: this.focus,
      hasHover: this.hover,
    };
  },

  computed: {
    /**
     * Sets the isChecked state for the stateModifiers.
     *
     * @returns {Boolean}
     */
    isChecked: {
      get() {
        return Array.isArray(this.modelValue) ? this.modelValue.includes(this?.value) : this.modelValue;
      },
      set(value) {
        return value;
      },
    },

    /**
     * Defines the default Modifier classes, have to be merged with custom classes or include directly in component.
     *
     * @returns {{state: *, active: *, disabled: *, focus: *, hover: *, checked: *}}
     */
    stateModifiers() {
      return {
        state: this.state,
        active: this.isActive,
        disabled: this.disabled,
        focus: this.hasFocus,
        hover: this.hasHover,
        checked: this.isChecked,
      };
    },
  },
};
